import { apiClient } from '../lib/api';
import { ENDPOINTS } from './endpoints';

export async function getEntity(entityId: string) {
  const res = await apiClient.get(ENDPOINTS.accounting.entity(entityId));
  return res.data;
}

export interface PendingWritebackDTO {
  id: string;
  organizationId: string;
  connectionId: string;
  entityId: string;
  operation: string;
  status: string; // 'PENDING' | 'RUNNING' | 'DONE' | 'FAILED'
  attempts: number;
  lastError: string | null;
  nextAttemptAt: string;
  completedAt: string | null;
  externalId: string | null;
  createdAt: string;
  updatedAt: string;
}

/** Returns the latest writeback row for a given entityId, or null if none. */
export async function fetchPendingWritebackForEntity(
  entityId: string,
  orgId: string,
): Promise<PendingWritebackDTO | null> {
  const { data } = await apiClient.get(ENDPOINTS.adminWritebacks.list, {
    params: { entityId, orgId },
  });
  return data as PendingWritebackDTO | null;
}

/** Resets a FAILED writeback back to PENDING for the worker to retry. */
export async function retryWriteback(id: string, orgId: string): Promise<PendingWritebackDTO> {
  const { data } = await apiClient.post(ENDPOINTS.adminWritebacks.retry(id), null, {
    params: { orgId },
  });
  return data as PendingWritebackDTO;
}
